var map = {
	"./Digi.png": 4358,
	"./Latch + Code Secure Lock.png": 6742,
	"./Latch + Eurocylinder Lock.png": 7294,
	"./TGV.png": 9464,
	"./center.png": 5579,
	"./freestyle.png": 4350,
	"./horizontal.png": 535,
	"./left.png": 332,
	"./none.png": 9646,
	"./right.png": 1132,
	"./steel.png": 3587,
	"./vertical.png": 2288
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2715;